import { render, staticRenderFns } from "./CategoryItem.vue?vue&type=template&id=8ab526e6&"
import script from "./CategoryItem.vue?vue&type=script&lang=js&"
export * from "./CategoryItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/fhartwig/Sites/Plenty Update/pp-weberbuero/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ab526e6')) {
      api.createRecord('8ab526e6', component.options)
    } else {
      api.reload('8ab526e6', component.options)
    }
    module.hot.accept("./CategoryItem.vue?vue&type=template&id=8ab526e6&", function () {
      api.rerender('8ab526e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/itemList/CategoryItem.vue"
export default component.exports